import { render, staticRenderFns } from "./GenericFieldInput.vue?vue&type=template&id=4b3728b0&scoped=true&"
import script from "./GenericFieldInput.vue?vue&type=script&lang=js&"
export * from "./GenericFieldInput.vue?vue&type=script&lang=js&"
import style0 from "./GenericFieldInput.vue?vue&type=style&index=0&id=4b3728b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3728b0",
  null
  
)

export default component.exports